module.exports = __webpack_public_path__ + "img/hangyezixun.b968eb5d.jpg";